
const InvoicesStarter = ({ setCreateInvoice }) => {
    return (
        <div className="_2fnj">
            <div className="clarions-pods">
                <h3>It's time to receive your payment!</h3>
                <span className="frumpy-gel">It's easier than ever to send fantastic bills and get paid—we promise not to brag too much. Proceed now! Give it a shot.</span>
                <button onClick={() => setCreateInvoice(true)}>New Invoice</button>
            </div>
        </div>
    )
}

export default InvoicesStarter

